<template>
  <ConfirmModal
      color="green"
      icon="mdi-check"
      :maxWidth="500"
      itemKey="Ticket"
      :fetchData="fetchData"
      :setTitle="setTitle"
      :setQuestion="setQuestion"
      :confirmData="pricingAcceptData"
      @onConfirm="(response) => $emit('onPricingAccept', response)"
      v-bind="$attrs"
  />
</template>

<script>
  import Tickets from '@/services/tickets'

  import ConfirmModal from '@/components/_Part/_Modal/Confirm'

  export default {
    name: 'PricingAccept',
    props: [
      'id'
    ],
    emits: [
      'onPricingAccept'
    ],
    components: {
      ConfirmModal
    },
    methods: {
      fetchData() {
        return Tickets
          .read({
            id: this.id
          })
      },
      setTitle(Item) {
        return 'Prijať cenovú ponuku č.' + Item.id
      },
      setQuestion(Item) {
        return 'Naozaj chcete prijať cenovú ponuku č.' + Item.id + '?'
      },
      pricingAcceptData() {
        return Tickets
          .pricingAccept({
            id: this.id
          })
      }
    }
  }
</script>
